import { queryOptions } from '@tanstack/react-query';
import type { CityBroadcastStateDto } from '@upme/contracts';
import { api } from '../../app/api-client';
import { citiesKey } from '../cities/queries';

/** Вложен в citiesKey: инвалидация citiesKey обновляет и блок трансляции, и бейдж «Чат» в списке. */
export const cityBroadcastKey = (cityId: string) => [...citiesKey, cityId, 'broadcast'] as const;

export const cityBroadcastOptions = (cityId: string) =>
  queryOptions({
    queryKey: cityBroadcastKey(cityId),
    queryFn: () => api.get(`admin/cities/${cityId}/broadcast`).json<CityBroadcastStateDto>(),
    // Планировщик тикает раз в минуту; в скрытой вкладке react-query не опрашивает.
    refetchInterval: 60_000,
  });
